<template>
	<section class="rooms-items">
		<div class="row category-row">
			<div v-for="(category, index) in items" :key="index" class="category">
				<div class="columns column12">
					<h3>{{ category.header }}</h3>
				</div>
				<div v-for="item in category.items" :key="item.pageID" class="columns column4">
					<nuxt-link :to="localePath(`/${item.filename}`)">
						<picture>
							<source :srcset="item.imageOverviewWebp" type="image/webp" />
							<source :srcset="item.imageOverview" />
							<img :src="item.imageOverview" :alt="item.imageOverviewAlt" loading="lazy" />
						</picture>
					</nuxt-link>
					<h3>{{ item.title || item.header }}</h3>
					<div v-parse-links v-html="item.contentOverview" />
					<nuxt-link :to="localePath(`/${item.filename}`)" class="button button-no-fill">
						{{ $t('readMore') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();
</script>

<script>
export default {
	name: 'HighlightsIndex',
	props: {
		items: { type: Array, default: () => [] },
	},
};
</script>

<style lang="scss" scoped>
#gmap {
	height: 600px;
	margin: 50px 0 0;
	display: none !important;

	h3,
	p {
		font-family: MessinaSerif, serif;
	}
}

.category {
	margin: 20px 0 40px;
	width: 100%;
	display: flex;
	flex-flow: row wrap;
}

.rooms-items {
	margin-bottom: 5px;
	padding: 50px 0;

	.row {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
	}

	h3 {
		margin: 0;
	}

	.column12 {
		h3 {
			margin: 0 0 20px;
		}
	}

	img {
		margin: 20px 0;
	}
}
</style>
